<div #toolbar [id]="toolbarId" class="ql-toolbar ql-snow" *ngIf="showToolbar">
  <!-- select에 붙인 aria-label은 Quill이 role 없는 래퍼로 복사해 무시된다 — 피커 이름은 labelToolbarPickers()가 붙인다. -->
  <select class="ql-header" *ngIf="toolbarOptions?.includes('header')">
    <option value="2"></option>
    <option value="3"></option>
    <option selected></option>
  </select>
  <select class="ql-size" *ngIf="toolbarOptions?.includes('size')">
    <option value="small"></option>
    <option selected></option>
    <option value="large"></option>
    <option value="huge"></option>
  </select>
  <button type="button" class="ql-bold" aria-label="굵게" *ngIf="toolbarOptions?.includes('bold')"></button>
  <button type="button" class="ql-underline" aria-label="밑줄" *ngIf="toolbarOptions?.includes('underline')"></button>
  <button type="button" class="ql-strike" aria-label="취소선" *ngIf="toolbarOptions?.includes('strike')"></button>
  <select class="ql-color" *ngIf="toolbarOptions?.includes('color')"></select>
  <select class="ql-background" *ngIf="toolbarOptions?.includes('background')"></select>
  <button type="button" class="ql-link" aria-label="링크" *ngIf="toolbarOptions?.includes('link')"></button>
  <button type="button" class="ql-image" aria-label="이미지" *ngIf="toolbarOptions?.includes('image')"></button>
  <button type="button" class="ql-video" aria-label="동영상" *ngIf="toolbarOptions?.includes('video')"></button>
  <button type="button" class="ql-list" value="ordered" aria-label="번호 목록" *ngIf="toolbarOptions?.includes('list-ordered')"></button>
  <button type="button" class="ql-list" value="bullet" aria-label="글머리 기호 목록" *ngIf="toolbarOptions?.includes('list-bullet')"></button>
  <select class="ql-align" *ngIf="toolbarOptions?.includes('align')"></select>
  <button type="button" class="ql-clean" aria-label="서식 지우기" *ngIf="toolbarOptions?.includes('clean')"></button>
</div>

<div #editorWrap class="dq-editor-wrap" [class.dq-disabled]="isDisabled">
  <div #editorContainer [style]="editorStyle"></div>

  <div
    #altPanel
    class="dq-alt-panel"
    *ngIf="altTarget"
    role="dialog"
    [attr.aria-labelledby]="altLabelId"
    [attr.aria-describedby]="altHelpId"
    [style.top.px]="altPanelTop"
    [style.left.px]="altPanelLeft"
    [style.width.px]="altPanelWidth"
    (keydown.escape)="closeAltEditor()"
  >
    <label class="dq-alt-label" [id]="altLabelId" [attr.for]="altInputId">대체 텍스트 (alt)</label>
    <input
      #altInput
      class="dq-alt-input"
      type="text"
      [id]="altInputId"
      [value]="altDraft"
      [attr.maxlength]="altMaxLength"
      [attr.aria-invalid]="altError ? 'true' : null"
      placeholder="예) 논밭 사이 흙길을 걷는 여행자들"
      (input)="altDraft = $any($event.target).value"
      (keydown.enter)="$event.preventDefault(); saveAlt()"
    />
    <p class="dq-alt-help" [id]="altHelpId">
      화면에는 보이지 않지만 <strong>구글 이미지 검색 노출</strong>과 스크린리더 낭독에 그대로 쓰여요. 사진 속 장면을
      한 문장으로 적어주세요.
    </p>
    <p class="dq-alt-error" *ngIf="altError" role="alert">{{ altError }}</p>
    <div class="dq-alt-actions">
      <button type="button" class="dq-alt-btn" (click)="closeAltEditor()">취소</button>
      <button type="button" class="dq-alt-btn dq-alt-btn-primary" (click)="saveAlt()">저장</button>
    </div>
  </div>
</div>
